// @flow
// React Libs
import React from 'react';
// Components
import Tooltip from '../../../../../Resources/Common/Tooltip';
import SimpleDocumentComponent from '../../../Documents/SimpleDocumentComponent';

type Props = {
  hasRights: boolean,
  blocked: boolean,
  proposalUid: string
};

export default function FinancialStatements({
  hasRights,
  blocked,
  proposalUid
}: Props) {
  return (
    <SimpleDocumentComponent
      title="Liasse fiscale N-1"
      tooltip={Tooltip.DocumentProjectFinancialStatements.document}
      blocked={blocked}
      hasRights={hasRights}
      proposalUid={proposalUid}
    />
  );
}
